// @ts-nocheck
import { removeCookie } from "@insite/client-framework/Common/Cookies";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import constants from "@store/constants";
import { useIsAuthenticated } from "@store/Framework/Store/Context/ContextHooks";
import { useEffect } from "react";
import { useSelector } from "react-redux";

export const useHandlePagesCookies = () => {
    useHandleChangeCustomerPageCookies();
};

export const useHandleChangeCustomerPageCookies = () => {
    const isAuthenticated = useIsAuthenticated();
    const { changeCustomerPageUrl, currentLocation, signinPageUrl } = useSelector((state: ApplicationState) => {
        return {
            changeCustomerPageUrl: getPageLinkByPageType(state, constants.pageType.changeCustomer)?.url,
            currentLocation: getLocation(state),
            signinPageUrl: getPageLinkByPageType(state, constants.pageType.signIn)?.url,
        };
    });

    useEffect(() => {
        if (changeCustomerPageUrl !== undefined && signinPageUrl !== undefined) {
            if (
                isAuthenticated &&
                currentLocation.pathname !== changeCustomerPageUrl &&
                currentLocation.pathname !== signinPageUrl
            ) {
                removeCookie(constants.cookies.showChangeCustomerPageVariant);
            }
        }
    }, [isAuthenticated, changeCustomerPageUrl, currentLocation]);
};
